// extracted by mini-css-extract-plugin
export default {"container":"admin_console_container__HRBx4","quotation_container":"admin_console_quotation_container__Rp7jP","areas_container":"admin_console_areas_container__i1kjY"};